import { defineComponent } from "vue"

export default defineComponent({
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      hours: this.endDate.getHours(),
      minutes: this.endDate.getMinutes(),
      seconds: this.endDate.getSeconds(),
    }
  },
  mounted() {
    this.setTimer()
  },
  methods: {
    setTimer() {
      const timer = setInterval(() => {
        this.getRemainingTime()

        // если таймер закончился
        if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
          clearInterval(timer)
          console.log("Time is up!")
        }
      }, 1000)
    },
    getRemainingTime() {
      const now = new Date()
      const target = new Date(this.endDate)

      const diff = target.getTime() - now.getTime()

      if (diff <= 0) {
        this.hours = 0
        this.minutes = 0
        this.seconds = 0
        return
      }

      const totalSeconds = Math.floor(diff / 1000)

      this.hours = Math.floor((totalSeconds % (24 * 3600)) / 3600)
      this.minutes = Math.floor((totalSeconds % 3600) / 60)
      this.seconds = totalSeconds % 60
    },
    pad(value: number) {
      return String(value).padStart(2, "0")
    },
  },
  watch: {
    endDate() {
      this.setTimer()
    },
  },
})
